/**
 * Levinson-Durbin algorithm
 */
export function computeLinearPredictiveCodingCoefficients(
  autoc: number[] | Float64Array,
  max_order: number,
  lpc_stride: number,
  fail: boolean,
  normalize: boolean,
  lpc: Float32Array | Float64Array,
) {

  let err = 0;
  let lpc_offset = 0;
  let lpc_last_offset = 0;
  let autoc_offset = 0;

  if (normalize) {
    err = autoc[0]!;
    autoc_offset++;
  }

  if (fail && (autoc[autoc_offset + max_order - 1] == 0 || err <= 0)) {
    throw 'lpc failure';
  }

  for (let i = 0; i < max_order; i++) {
    let r = -autoc[autoc_offset + i]!;
    if (normalize) {
      for(let j = 0; j < i; j++) {
        r -= lpc[lpc_last_offset + j]! * autoc[autoc_offset + i - j - 1]!;
      }

      if (err !== 0) {
        r /= err;
      }

      err *= 1 - (r * r);
    }

    lpc[lpc_offset + i] = r;

    // eslint-disable-next-line no-bitwise
    for (let j = 0; j < (i + 1) >> 1; j++) {
      const f = lpc[lpc_last_offset + j]!;
      const b = lpc[lpc_last_offset + i - 1 - j]!;
      lpc[lpc_offset + j] = f + (r * b);
      lpc[lpc_offset + i - 1 - j] = b + (r * f);
    }

    if (fail && err < 0) {
      throw 'lpc failure';
    }

    lpc_last_offset = lpc_offset;
    lpc_offset += lpc_stride;
  }

  return lpc;
}
